<template>
	<div>
		<b-modal :id="'all_account_statement'" size="xl" @shown="modalShown">
			<!-- <template #modal-title>
                <div class="d-flex">
                    <h6 class="m-0 fw-bold text-green">Product Statement</h6>
                    <div class="akkurate-small me-4">
                        <span v-if="rewrtieLoading">
                            <b-spinner small class="align-middle"></b-spinner>
                        </span>
                        <b-link v-else class="fw-semibold ms-2 akkurate-green">
                            <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" @click="refreshLoanTransactions(data.customer_id)" /></b-link>

                    </div>
                </div>

            </template>
             -->
			<div class="container mb-1">
				<div class="row">
					<form @submit.prevent="filterMemberTransactionSearch">
							<div class="row">
								
								<div class="col-5">
									<label>Start Date</label>
									<b-form-group
									id="start_date"
									label-for="start_date">
									<b-form-input
									class="mb-3 mt-2 field-container fields"
									type="date"
									v-model="filter.start_date"
									></b-form-input>
									</b-form-group>
								</div>
								<div class="col-5">
									<label>End Date</label>
									<b-form-group
									id="end_date"
									label-for="end_date">
									<b-form-input
									class="mb-3 mt-2 field-container fields"
									type="date"
									v-model="filter.end_date"
									></b-form-input>
									</b-form-group>
								</div>
								<div class="mt-auto col col">
									<b-button type="submit" :disabled="isSearching" class="akkurate-green-btn akkurate-auth-size w-100 mb-3"><font-awesome-icon class="me-2" :icon="['fas', 'search']" />{{ search }}</b-button>
								</div>
						</div>
					</form>
				</div>
			</div>

			<hr style="margin: 0.25rem" />

			<div class="container text-start" ref="pdfContent">
				<div class="row">
					<div
						class="col-md-4 col-4 d-flex align-items-center flex-column bd-highlight">
						<img
							class="img-fluid img-visibility statement-logo"
							:src="require('@/assets/img/default_logo.png')" />
						<p
							class="mt-2 akkurate-green fw-bold mt-auto p-2 bd-highlight">
							CONSOLIDATED ACCOUNTS STATEMENT
						</p>
					</div>
					<div
						class="d-flex align-items-end flex-column bd-highlight col-md-8 col-8 text-end">
						<p class="fw-bold text-uppercase mb-0">
							{{ institution?.name }}
						</p>
						<p class="fw-bold">{{ institution?.motto }}</p>
						<p class="mb-0 akkurate-small">
							{{ institution?.postal }}
						</p>
						<p class="mb-0 akkurate-small">
							{{ institution?.telephone }}
						</p>
						<p class="akkurate-small">{{ institution?.email }}</p>
						<p
							class="fw-bold text-end mt-auto p-2 bd-highlight text-uppercase">
							{{
								new Intl.DateTimeFormat("en-GB", {
									day: "numeric",
									month: "long",
									year: "numeric",
								}).format(Date.now())
							}}
						</p>
					</div>
				</div>
				<hr class="mt-0 akkurate-dark" />
				<!-- Savings Statements -->
				<div class="text-center text-danger my-2" v-if="isLoading">
					<b-spinner class="align-middle"></b-spinner>
					<strong>Loading...</strong>
				</div>
				<div v-for="account in form.accounts" class="mb-4 mt-4">
					<div v-if="account?.account?.account_type?.name == 'LOANS'">
						<div class="row">
							<div class="col-md-5">
								<h6 class="akkurate-dark report-l-text">
									ACCOUNT DETAILS
								</h6>
								<hr class="w-100 mt-0" />
								<div class="row akkurate-small">
									<div class="col-md-4 fw-bold akkurate-gray">
										Customer Name
									</div>
									<div class="col-md-8">
										{{ getFullNameAndID }}
									</div>
									<div class="col-md-4 fw-bold akkurate-gray">
										Ext. Code
									</div>
									<div class="col-md-8">
										{{
											account?.account?.customer
												.external_code
										}}
									</div>
									<div class="col-md-4 fw-bold akkurate-gray">
										Loan Code
									</div>
									<div class="col-md-8">
										{{ account?.loan_number }}
									</div>
									<div class="col-md-4 fw-bold akkurate-gray">
										Loan Type
									</div>
									<div class="col-md-8">
										{{ account?.loan_product?.name }}
									</div>
									<div class="col-md-4 fw-bold akkurate-gray">
										Branch
									</div>
									<div class="col-md-8">
										{{ account?.branch?.name }}
									</div>
									<div class="col-md-4 fw-bold akkurate-gray">
										Currency
									</div>
									<div class="col-md-8">
										{{ institution?.currency_code }}
									</div>
								</div>
							</div>
							<div class="col-md-3"></div>
							<div class="col-md-4">
								<h6 class="akkurate-dark report-l-text">
									ACCOUNT SUMMARY
								</h6>
								<hr class="w-100 mt-0" />
								<div class="row akkurate-small">
									<div class="col-md-5 fw-bold akkurate-gray">
										Principal
									</div>
									<div class="col-md-7 report-s-text">
										{{ institution?.currency_code }}
										{{
											displayNumber(
												account?.principal_amount,
											)
										}}
									</div>
									<div class="col-md-5 fw-bold akkurate-gray">
										Expected Interest
									</div>
									<div class="col-md-7 report-s-text">
										{{ institution?.currency_code }}
										{{
											displayNumber(
												account?.expected_interest,
											)
										}}
									</div>
									<div class="col-md-5 fw-bold akkurate-gray">
										Interest Due
									</div>
									<div class="col-md-7 report-s-text">
										{{ institution?.currency_code }}
										{{
											displayNumber(account?.interest_due)
										}}
									</div>
									<div class="col-md-5 fw-bold akkurate-gray">
										Rate
									</div>
									<div class="col-md-7 report-s-text">
										{{ account?.interest_rate }}% /
										{{ account?.interest_rate_frequency }}
									</div>
									<div class="col-md-5 fw-bold akkurate-gray">
										Tenure
									</div>
									<div class="col-md-7 report-s-text">
										{{ account?.tenor }}
										{{ account?.tenor_interval }}
									</div>
									<div class="col-md-5 fw-bold akkurate-gray">
										Status
									</div>
									<div class="col-md-7 report-s-text">
										{{ account.status }}
									</div>
									<div class="col-md-5 fw-bold akkurate-gray">
										Interest Balance
									</div>
									<div class="col-md-7 report-s-text">
										{{ account.interest_balance }}
									</div>
									<div class="col-md-5 fw-bold akkurate-gray">
										Principal Balance
									</div>
									<div class="col-md-7 report-s-text">
										{{ account.principal_balance }}
									</div>
									<hr class="w-100 mt-0 mb-2" />
									<div class="col-md-5 fw-bold akkurate-gray">
										Current Balance
									</div>
									<div class="col-md-7 fw-bold report-s-text">
										{{ institution?.currency_code }}
										{{
											displayNumber(
												account?.total_loan_balance,
											)
										}}
									</div>
								</div>
							</div>
						</div>

						<div class="row mt-5">
							<div class="col-6">
								<h6 class="report-l-text">
									ACCOUNT TRANSACTIONS
								</h6>
							</div>
							<div class="col-6 text-end">
								<h6 class="report-l-text">
									<span class="fw-bold">From:</span>
									{{ filter?.start_date }}
									<span class="fw-bold">To:</span>
									{{ filter?.end_date }}
								</h6>
							</div>
							<div class="col-12 d-flex my-3 flex-wrap">
								<div class="d-flex align-items-center">
									<p
										class="mb-0 akkurate-extra-small me-2 akkurate-dark">
										<font-awesome-icon
											:icon="['fas', 'circle']" />
									</p>
									<span class="akkurate-extra-small me-2"
										>Prev.BAL(Previous Balance)</span
									>
								</div>
								<div class="d-flex align-items-center">
									<p
										class="mb-0 akkurate-extra-small me-2 akkurate-orange-text">
										<font-awesome-icon
											:icon="['fas', 'circle']" />
									</p>
									<span class="akkurate-extra-small me-2"
										>PP(Principal Paid)</span
									>
								</div>
								<div class="d-flex align-items-center">
									<p
										class="mb-0 akkurate-extra-small me-2 akkurate-danger">
										<font-awesome-icon
											:icon="['fas', 'circle']" />
									</p>
									<span class="akkurate-extra-small me-2"
										>PB(Principal Balance)</span
									>
								</div>
								<div class="d-flex align-items-center">
									<p
										class="mb-0 akkurate-extra-small me-2 akkurate-green">
										<font-awesome-icon
											:icon="['fas', 'circle']" />
									</p>
									<span class="akkurate-extra-small me-2"
										>IP(Interest Paid)</span
									>
								</div>
								<div class="d-flex align-items-center">
									<p
										class="mb-0 akkurate-extra-small me-2 akkurate-blue-text">
										<font-awesome-icon
											:icon="['fas', 'circle']" />
									</p>
									<span class="akkurate-extra-small me-2"
										>IB(Interest Balance)</span
									>
								</div>
							</div>
							<div class="col-md-12 trans_account akkurate-small">
								<b-table
									striped
									small
									:busy.sync="isBusy"
									:items="account.account.transactions"
									:fields="loanFields">
									<template #cell(debit)="data">
										<p
											class="mb-0"
											v-if="
												data?.item?.transaction_type ==
												'Loan Disbursed'
											">
											{{
												displayNumber(
													data?.item?.trans_amount,
												)
											}}
										</p>
									</template>

									<template #cell(credit)="data">
										<p
											class="mb-0"
											v-if="
												data?.item?.transaction_type ==
												'Loan Repayment'
											">
											{{
												displayNumber(
													data?.item?.trans_amount,
												)
											}}
										</p>
									</template>

									<template #cell(description)="data">
										<p class="mb-0">
											{{ data?.item?.transaction_type }}
											By
											{{ data?.item?.transaction_mode }}
										</p>
									</template>
								</b-table>
							</div>
						</div>
					</div>

					<!-- Normal Reciept -->
					<div v-else>
						<div class="row">
							<div class="col-md-5">
								<h6 class="akkurate-dark report-l-text">
									PRODUCT DETAILS
								</h6>
								<hr class="w-100 mt-0" />
								<div class="row akkurate-small">
									<div
										class="col-md-4 fw-bold akkurate-gray report-l-text">
										Customer Name
									</div>
									<div class="col-md-8">
										{{ getFullNameAndID }}
									</div>
									<div
										class="col-md-4 fw-bold akkurate-gray report-l-text">
										Account Name
									</div>
									<div class="col-md-8">
										{{ account.account_type?.name }}
									</div>
									<div
										class="col-md-4 fw-bold akkurate-gray report-l-text">
										Account Number
									</div>
									<div class="col-md-8">
										{{ account.account_number }}
									</div>
									<div
										class="col-md-4 fw-bold akkurate-gray report-l-text">
										Branch
									</div>
									<div class="col-md-8">
										{{ account.branch?.name }}
									</div>
									<div
										class="col-md-4 fw-bold akkurate-gray report-l-text">
										Currency
									</div>
									<div class="col-md-8 report-s-text">
										{{ institution?.currency_code }}
									</div>
								</div>
							</div>
							<div class="col-md-3"></div>
							<div class="col-md-4">
								<h6 class="akkurate-dark report-l-text">
									PRODUCT SUMMARY
								</h6>
								<hr class="w-100 mt-0" />
								<div class="row akkurate-small">
									<div
										class="col-md-5 fw-bold akkurate-gray report-l-text">
										Opening Balance
									</div>
									<div class="col-md-7">
										{{
											displayNumber(
												account.opening_balance,
											)
										}}
									</div>
									<div
										class="col-md-5 fw-bold akkurate-gray report-l-text">
										Total Debit
									</div>
									<div class="col-md-7">
										{{
											displayNumber(account.total_debits)
										}}
									</div>
									<div
										class="col-md-5 fw-bold akkurate-gray report-l-text">
										Total Credit
									</div>
									<div class="col-md-7">
										{{
											displayNumber(account.total_credits)
										}}
									</div>
									<hr class="w-100 mt-0 mb-2" />
									<div
										class="col-md-5 fw-bold akkurate-gray akkurate-small report-l-text">
										Closing Balance
									</div>
									<div
										class="col-md-7 fw-bold report-l-text akkurate-small">
										{{
											displayNumber(
												account.closing_balance,
											)
										}}
									</div>
								</div>
							</div>
						</div>
						<div class="row mt-5">
							<div class="col-md-6">
								<h6 class="report-l-text">
									PRODUCT TRANSACTIONS
								</h6>
							</div>
							<div class="col-md-6 text-end">
								<h6 class="report-l-text">
									<span class="fw-bold">From:</span>
									{{ filter.start_date }}
									<span class="fw-bold">To:</span>
									{{ filter.end_date }}
								</h6>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12 trans_account akkurate-small">
								<b-table
									striped
									small
									:busy.sync="isBusy"
									:items="account.transactions"
									:fields="fields">
									<template #table-busy>
										<div
											class="text-center text-danger my-2">
											<b-spinner
												class="align-middle"></b-spinner>
											<strong>Loading...</strong>
										</div>
									</template>
									<template
										#cell(reference)="data"
										class="text-nowrap text-center">
										<p class="mb-0 text-nowrap">
											{{ transactionLedgerReference(data.item) }}
										</p>
									</template>
									<template
										#cell(trans_date)="data"
										class="text-nowrap text-center"
										style="width: 70px !important">
										<p class="mb-0 text-nowrap">
											{{ data.item?.trans_date }}
										</p>
									</template>
									<template #cell(debit)="data">
										<p
											class="mb-0"
											v-if="
												data.item.transaction_type ==
													'Withdrawal' ||
												data?.item?.transaction_type ==
													'Loan Repayment'
											">
											{{
												displayNumber(
													data.item.trans_amount,
												)
											}}
										</p>
									</template>
									<template #cell(credit)="data">
										<p
											class="mb-0"
											v-if="
												data.item.transaction_type ==
													'Deposit' ||
												data?.item?.transaction_type ==
													'Loan Disbursed'
											">
											{{
												displayNumber(
													data.item?.trans_amount,
												)
											}}
										</p>
									</template>
									<template #cell(teller)="data">
										<p class="mb-0">
											{{
												data.item?.created_user
													?.first_name
											}}
											{{
												data.item?.created_user?.surname
											}}
										</p>
									</template>
									<template #cell(current_balance)="data">
										<p class="mb-0">
											{{
												displayNumber(
													data.item?.current_balance,
												)
											}}
										</p>
									</template>
									<template #cell(previous_balance)="data">
										<p class="mb-0">
											{{
												displayNumber(
													data.item?.previous_balance,
												)
											}}
										</p>
									</template>
									<template #cell(trans_status)="data">
										<span
											class="badge"
											:class="
												data.item.trans_status ==
												'COMPLETED'
													? 'bg-success'
													: data.item.trans_status ==
													  'REVERSED'
													? 'bg-danger'
													: 'bg-warning'
											"
											>{{ data.item.trans_status }}</span
										>
									</template>
								</b-table>
							</div>
						</div>
					</div>
					<div class="col-md-12 text-center">
						********************************* END OF STATEMENT
						*********************************
					</div>
					<hr class="mt-2 mb-2 akkurate-dark" />
				</div>
			</div>
			<template #modal-footer>
				<div class="w-100">
					<!-- begin loader -->
					<!-- <beat-loader-component class="float-left" v-if="isLoading"
                        :isLoading="isLoading"></beat-loader-component> -->
					<!-- end loader -->
					<!-- Emulate built in modal footer ok and cancel button actions -->
					<b-button
						@click="printPDF"
						type="button"
						class="akkurate-green-btn download-btn ms-2 float-right"
						><span class="small me-2"
							><font-awesome-icon
								:icon="['fas', 'book']" />Print</span
						></b-button
					>
					<b-button
						@click="downloadPDF"
						class="akkurate-green-btn download-btn ms-2 float-right"
						><span class="small"
							><font-awesome-icon :icon="['fas', 'save']" />
							Download</span
						></b-button
					>
				</div>
			</template>
		</b-modal>
	</div>
</template>
<script>
	import ApiService from "@/core/services/api.service";
	import { transactionLedgerReference } from "@/utils/transactionLedgerReference.js";
	import StatementFilter from "./form/StatementFilter.vue";
	import html2pdf from "html2pdf.js";
	import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
	export default {
		props: ["member_id", "institution", "user"],
		components: {
			StatementFilter,
			StatementInstitution,
		},
		oncreated() {
			// this.getAccountStatement();
			this.getMember();
		},
		data() {
			return {
				member: null,
				filter: {
					account_number: "",
					start_date: this.getOneMonthBeforeDate(),
					end_date: new Date().toISOString().substr(0, 10),
				},
				frontImgUrl: "",
				backImgUrl: "",
				imageLoaded: false,
				form: {
					accounts: [],
					customer: [],
					account_type: [],
					branchs: [],
				},
				rewrtieLoading: false,
				total_credit: 0,
				total_debit: 0,
				fields: [
					{key: "trans_date", label: "Date"},
					{key: "reference", label: "Reference"},
					{key: "transaction_mode", label: "Mode"},
					{key: "trans_status", label: "Status"},
					// { key: 'code', label: 'Trans. ID' },
					{key: "narration", label: "Description"},
					{key: "debit", label: "Debit"},
					{key: "credit", label: "Credit"},
					{key: "previous_balance", label: "Prev.Balance"},
					{key: "current_balance", label: "Balance"},
					// { key: 'teller', label: 'Teller' },
				],
				loanFields: [
					{
						key: "trans_date",
						label: "Date",
					},

					{
						key: "description",
						label: "Description",
					},
					{
						key: "debit",
						label: "Debit",
					},
					{
						key: "credit",
						label: "Credit",
					},

					{
						key: "previous_balance",
						label: "Prev.BAL",
					},
					{
						key: "principal",
						label: "Principal Paid",
					},
					{
						key: "principal_balance",
						label: "Principal balance",
					},
					{
						key: "interest",
						label: "Interest Paid",
					},
					{
						key: "interest_balance",
						label: "Interest balance",
					},
				],
				items: [],
				search: "Search",
				isSearching: false,
				isBusy: false,
				isLoading: false,
			};
		},
		computed: {
			getFullNameAndID() {
				let first_name =
					this.member.first_name != null
						? this.member.first_name
						: "";
				let middlename =
					this.member.middlename != null
						? this.member.middlename
						: "";
				let last_name =
					this.member.last_name != null ? this.member.last_name : "";
				let code = this.member.code != null ? this.member.code : "";
				return (
					first_name +
					" " +
					middlename +
					" " +
					last_name +
					" - " +
					code
				);
			},
		},
		mounted() {
			this.getBranchDropDown();
		},
		methods: {
			transactionLedgerReference,
			filterMemberTransactionSearch() {
				this.getMember();
			},
			async getMember() {
				this.form.accounts = [];
				this.isLoading = true;
				this.isBusy = true;
				this.isSearching = true;

				try {
					const response = await ApiService.get(
						"/customers/view/" + this.member_id,
					);
					this.member = response.data.data;

					let sharesAcct = [];
					let savingsAcct = [];
					let loansAcct = [];
					let fdAcct = [];
					let otherAcct = [];

					for (const account of this.member.accounts) {
						if (account.account_type?.base_type == "Shares")
							sharesAcct.push(account);
						else if (account.account_type?.base_type == "Savings")
							savingsAcct.push(account);
						else if (account.account_type?.base_type == "Loan")
							loansAcct.push(account);
						else if (
							account.account_type?.base_type == "Fixed_Deposits"
						)
							fdAcct.push(account);
						else otherAcct.push(account);
					}

					// const arrangedArray = [...this.member.accounts]
					//     .sort((a, b) => {
					//         const aOrder = orderMap[a?.account_type?.base_type] ?? 999;
					//         const bOrder = orderMap[b?.account_type?.base_type] ?? 999;
					//         return aOrder - bOrder;
					//     });

					const arrangedArray = [
						...sharesAcct,
						...savingsAcct,
						...loansAcct,
						...fdAcct,
						...otherAcct,
					];

					// console.log("Arranged Arr: ", arrangedArray);

					for (const account of arrangedArray) {
						if (account.account_type?.base_type == "Loan") {
							console.log(
								"Fetching loan statement for account:",
								account,
							);
							const stat = await this.getLoanStatements(
								account.loan.loan_number,
								account.branch_id,
							);
							this.form.accounts.push(stat);
						} else {
							const stat = await this.getStatements(
								account.account_number,
							);
							this.form.accounts.push(stat);
						}
					}
					console.log("Accounts:", this.form.accounts);

					// await this.loadAllTransactions();
				} catch (error) {
					swal.fire({
						text:
							error.response?.data?.message ||
							"Something went wrong",
						icon: "error",
						confirmButtonText: "okay",
						buttonsStyling: false,
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
						},
					});
				} finally {
					this.isLoading = false;
					this.isBusy = false;
					this.isSearching = false;
				}
			},

			async getStatements(account_number) {
				let statement = [];
				this.isBusy = true;

				await ApiService.query(
					`/accounts/statement/${account_number}`,
					{
						params: {
							start_date: this.filter.start_date,
							end_date: this.filter.end_date,
						},
					},
				)
					.then((response) => {
						this.isBusy = false;
						console.log(response);
						statement = response.data.account;
					})
					.catch((error) => {
						this.isBusy = false;
						console.error("error",error)
					});

				return statement;
			},

			async getLoanStatements(loan_number, branch_id = null) {
				// console.log(this.filter.start_date);
				let statement = [];
				this.isBusy = true;
				await ApiService.query("/loans/loanStatements", {
					params: {
						loan_number: loan_number,
						start_date: this.filter?.start_date,
						end_date: this.filter?.end_date,
					},
				})
					.then((response) => {
						statement = response.data.data;
						this.isBusy = false;
					})
					.catch((error) => {
						this.isBusy = false;
					});

				console.log(typeof statement);
				return {
					...statement,
					branch: this.form.branchs.find(
						(branch) => branch.id === branch_id,
					),
				};
			},
			async getBranchDropDown() {
				this.isBusy = true;
				await ApiService.get("/settings/branches/dropdown")
					.then((response) => {
						this.isBusy = false;
						// this.options.user_options = response.data?.users;
						// this.options.region_options = response.data?.regions;
						this.form.branchs = response.data?.regions;
						console.log("Branches: ", this.form.branchs);
					})
					.catch((error) => {
						this.isBusy = false;
					});
			},
			async getAccountStatement() {
				this.isSearching = true;
				this.search = "Processing...";
				this.isBusy = true;
				console.log(this.filter.account_number);
				this.filter.account_number = this.filter.account_number
					? this.filter.account_number
					: this.data.account_number;
				await ApiService.query(
					`/accounts/statement/${this.filter.account_number}`,
					{
						params: {
							start_date: this.filter.start_date,
							end_date: this.filter.end_date,
						},
					},
				)
					.then((response) => {
						this.isSearching = false;
						this.search = "Search";
						this.isBusy = false;
						this.form = response.data.account;
						this.items = response.data.account.transactions;
						// this.handleImageLoad();
					})
					.catch((error) => {
						this.isSearching = false;
						this.search = "Search";
						this.isBusy = false;
					});
			},
			handleImageLoad() {
				this.imageLoaded = true;
				this.frontImgUrl =
					this.details.account?.customer?.gh_card_front_path;
				this.backImgUrl =
					this.details.account?.customer?.gh_card_back_path;
			},
			downloadPDF() {
				console.log(this.items);

				const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
				// console.log("here");
				const pdfOptions = {
					margin: [0.3, 0.1, 1.2, 0.1],
					filename: "statement.pdf",
					image: {type: "jpeg", quality: 1.0},
					html2canvas: {
						scale: 4,
						useCORS: true,
						letterRendering: true,
					},
					jsPDF: {unit: "in", format: "a4", orientation: "portrait"},
					pagebreak: {
						mode: ["css", "legacy"],
					},
				};
				html2pdf()
					.from(content)
					.set(pdfOptions)
					.toPdf()
					.get("pdf")
					.then((pdf) => {
						var totalPages = pdf.internal.getNumberOfPages();
						var insit_name = this.institution.name;
						var insit_tele = this.institution.telephone;
						var insit_email = this.institution.email;
						var insit_motto = this.institution.motto;

						for (var i = 1; i <= totalPages; i++) {
							pdf.setPage(i);
							pdf.setFontSize(8);
							pdf.setTextColor(150);
							pdf.text(
								[
									"For Inquiries, Please Contact " +
										insit_name +
										", Customer Service on " +
										insit_tele +
										"",
									"or email us on " +
										insit_email +
										" " +
										insit_motto +
										"",
									"Page " + i + " of " + totalPages,
								],
								pdf.internal.pageSize.getWidth() / 2,
								pdf.internal.pageSize.getHeight() - 0.6,
								{align: "center"},
							);
						}
					})
					.save();
			},
			printPDF() {
				const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
				// console.log("here");
				const pdfOptions = {
					margin: [0.3, 0.1, 1.2, 0.1],
					filename: "statement.pdf",
					image: {type: "jpeg", quality: 1.0},
					html2canvas: {
						scale: 4,
						useCORS: true,
						letterRendering: true,
					},
					jsPDF: {unit: "in", format: "a4", orientation: "portrait"},
					pagebreak: {
						mode: ["css", "legacy"],
					},
				};
				html2pdf()
					.from(content)
					.set(pdfOptions)
					.toPdf()
					.get("pdf")
					.then((pdf) => {
						var totalPages = pdf.internal.getNumberOfPages();
						var insit_name = this.institution.name;
						var insit_tele = this.institution.telephone;
						var insit_email = this.institution.email;
						var insit_motto = this.institution.motto;
						for (var i = 1; i <= totalPages; i++) {
							pdf.setPage(i);
							pdf.setFontSize(8);
							pdf.setTextColor(150);
							pdf.text(
								[
									"For Inquiries, Please Contact " +
										insit_name +
										", Customer Service on " +
										insit_tele +
										"",
									"or email us on " +
										insit_email +
										" " +
										insit_motto +
										"",
									"Page " + i + " of " + totalPages,
								],
								pdf.internal.pageSize.getWidth() / 2,
								pdf.internal.pageSize.getHeight() - 0.6,
								{align: "center"},
							);
						}
						// Get the blob of the PDF
						return pdf.output("blob");
					})
					.then((pdfBlob) => {
						// Create a URL for the PDF blob
						var pdfUrl = URL.createObjectURL(pdfBlob);

						// Open the URL in a new tab
						const printWindow = window.open(
							pdfUrl,
							"_blank",
							"width=800,height=600",
						);
						printWindow.onload = () => {
							printWindow.print();
							URL.revokeObjectURL(pdfUrl);
						};
					})
					.catch((error) => {
						console.error("Error generating PDF:", error);
					});
			},
			filterAccountStatement() {
				this.getAccountStatement();
			},
			modalShown() {
				// this.getAccountStatement();
				this.getMember();
			},
			getOneMonthBeforeDate() {
				// Get today's date
				let currentDate = new Date();

				// Remove one month to the current date
				currentDate.setMonth(currentDate.getMonth() - 1);

				// Format the date as 'YYYY-MM-DD'
				return currentDate.toISOString().substr(0, 10);
			},
			async refreshLoanTransactions(customer_id) {
				console.log(this.data);
				this.rewrtieLoading = true;
				console.log(customer_id);
				await ApiService.post(`/transactions/rewrite`, {
					customer_id: customer_id,
				})
					.then((response) => {
						this.isLoadingSaving = false;
						this.$Progress.finish();
						toast.fire({
							icon: "success",
							title: response.data.message,
						});
						this.isSaving = false;
						this.filterAccountStatement();
						this.rewrtieLoading = false;
					})
					.catch((error) => {
						this.isSaving = false;
						this.$Progress.fail();
						if (error.response.data.errors) {
							this.form.errors = error.response?.data?.errors;
						}
						this.rewrtieLoading = false;
					});
			},
		},
	};
</script>
